import { createContext, type PropsWithChildren, useContext, useState } from "react"

import { storage } from "@/common/services/localStorage.service"

interface ShowResourceIdsContextType {
  showResourceIds: boolean
  toggleShowResourceIds: () => void
}

const ShowResourceIdsContext = createContext<ShowResourceIdsContextType | undefined>(undefined)

export function ShowResourceIdsProvider({ children }: PropsWithChildren) {
  const [showResourceIds, setShowResourceIds] = useState<boolean>(() => {
    return storage.get<boolean>(storage.keys.SHOW_RESOURCE_IDS, false)
  })

  const toggleShowResourceIds = () => {
    setShowResourceIds((prev) => {
      const newValue = !prev
      storage.set(storage.keys.SHOW_RESOURCE_IDS, newValue)
      return newValue
    })
  }

  return (
    <ShowResourceIdsContext.Provider value={{ showResourceIds, toggleShowResourceIds }}>
      {children}
    </ShowResourceIdsContext.Provider>
  )
}

export function useShowResourceIds() {
  const context = useContext(ShowResourceIdsContext)
  if (context === undefined) {
    throw new Error("useShowResourceIds must be used within a ShowResourceIdsProvider")
  }
  return context
}
